<template>
  <div class="m-edition-billing-academy-migration">
    <div class="m-edition-billing-academy-migration-item-left">
      <MoleculeEditionBillingAcademyMigrationSearchSale
        item="0"
        :loading="loading[0]"
        @readVentaDatosMigracion="readVentaDatosMigracion"
      />
      <MoleculeEditionBillingAcademyMigrationSaleInfo
        :loading="loading[0]"
        :venta="ventas[0]"
      />
    </div>

    <AtomButtonSecondary
      v-if="Object.keys(ventas[0]).length > 0 &&
        Object.keys(ventas[1]).length > 0 && ventas[0].licencia &&
        ventas[1].licencia && (ventas[0].academia || ventas[1].academia)"
      :button-secondary="buttonSecondary.migrateAcademy"
      :disabled="loading[0] || loading[1]"
      @migrateAcademy="migrateAcademy"
    />

    <div class="m-edition-billing-academy-migration-item-right">
      <MoleculeEditionBillingAcademyMigrationSearchSale
        item="1"
        :loading="loading[1]"
        @readVentaDatosMigracion="readVentaDatosMigracion"
      />
      <MoleculeEditionBillingAcademyMigrationSaleInfo
        :loading="loading[1]"
        :venta="ventas[1]"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingAcademyMigration',

  components: {
    MoleculeEditionBillingAcademyMigrationSaleInfo: () => import('@/components/molecules/MoleculeEditionBillingAcademyMigrationSaleInfo'),
    MoleculeEditionBillingAcademyMigrationSearchSale: () => import('@/components/molecules/MoleculeEditionBillingAcademyMigrationSearchSale')
  },

  data () {
    return {
      buttonSecondary: {
        migrateAcademy: {
          class: 'a-button-secondary a-button-billing-secondary a-tooltip-primary a-tooltip-bottom migrate',
          component: '',
          icon: 'far fa-exchange-alt',
          method: 'migrateAcademy',
          text: '',
          tooltip: 'Migrar',
          type: 'button'
        }
      },

      defaultResources: {
        alumnos: 0,
        maximo_alumnos: 0,
        maximo_emails: 0,
        maximo_mapas: 0,
        maximo_productos: 0,
        maximo_proyectos: 0,
        maximo_puntos_venta: 0,
        productos: 0,
        proyectos: 0,
        puntos_venta: 0
      },

      loading: [false, false],
      ventas: [{}, {}]
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      if (this.$modal.methodToRun === 'updateMigratedData') {
        this.readVentaDatosMigracion({ id: this.ventas[0].venta.venta.id_venta, index: 0 })
        this.readVentaDatosMigracion({ id: this.ventas[1].venta.venta.id_venta, index: 1 })
        this.$modal.closeModal()
        this.$alerts.pushAlertNotTranslated('La academia fue migrada exitosamente.')
      }
    }
  },

  methods: {
    migrateAcademy () {
      this.$modal.showModal('MoleculeEditionBillingAcademyMigrationModalMigrateAcademy', this.ventas)
    },

    readVentaDatosMigracion (venta) {
      if (!this.loading[venta.index] && venta.id.length > 0) {
        this.$set(this.loading, venta.index, true)
        this.$services.read('ventas', 'readVentaDatosMigracion', {}, [venta.id])
          .then(response => {
            console.log(response.data)
            this.$set(this.ventas, venta.index, response.data)
            if (this.ventas[venta.index].licencia && !this.ventas[venta.index].recursos) {
              this.ventas[venta.index].recursos = Object.assign({}, this.defaultResources)
              this.ventas[venta.index].recursos.maximo_alumnos = this.ventas[venta.index].licencia.maximo_alumnos
              this.ventas[venta.index].recursos.maximo_emails = this.ventas[venta.index].licencia.maximo_emails
              this.ventas[venta.index].recursos.maximo_mapas = this.ventas[venta.index].licencia.maximo_mapas
              this.ventas[venta.index].recursos.maximo_productos = this.ventas[venta.index].licencia.maximo_productos
              this.ventas[venta.index].recursos.maximo_proyectos = this.ventas[venta.index].licencia.maximo_proyectos
              this.ventas[venta.index].recursos.maximo_puntos_venta = this.ventas[venta.index].licencia.maximo_puntos_venta
            }
            this.$set(this.loading, venta.index, false)
          })
          .catch(error => {
            console.log(error)
            this.$set(this.ventas, venta.index, {})
            this.$set(this.loading, venta.index, false)
          })
      }
    }
  }
}
</script>
